export default __webpack_public_path__ + "static/media/MetafightWelcome-min.c2d88117.png";